import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useApi } from '../../utils/hooks';
import ErrorComponent from '../../components/Error';

import ArsenalWeekMenu from '../../components/Arsenal/ArsenalWeekMenu';
import ArsenalSimpleMenu from '../../components/Arsenal/ArsenalSimpleMenu';

import '../../utils/styles/Arsenal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

function ArsenalDetails() {
    const { menu } = useParams();
    const navigate = useNavigate();

    // Replace '-' with ' ' and capitalize the first letter
    const menuFormat = menu
        .replace(/-/g, ' ')
        .replace(/^\w/, (c) => c.toUpperCase());

    // Mapping page name to API endpoint
    const apiMapping = {
        'menu-de-la-semaine': 'week-menu',
        'plats-brasserie': 'brasserie-dish',
        'snacks': 'snack',
        'desserts': 'dessert',
        'boissons': 'drink',
        'plats-exclusifs': 'special-dish',
    };

    // Call the API to fetch the data
    const { data, loading, error } = useApi(`arsenal-${apiMapping[menu]}/`);

    // Display the error message if the request fails
    if (loading) return <div className="container">Chargement...</div>;

    // Display a loading message while the request is pending
    if (error) return <ErrorComponent title="Error" errorObject={error} />;

    return (
        <div className="container">
            <div>
                <button
                    className="circle"
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    <FontAwesomeIcon icon={faChevronLeft} size="xl" />
                </button>
                <p className="title-3">{menuFormat}</p>
            </div>

            {menu === 'menu-de-la-semaine' ? (
                <ArsenalWeekMenu dataMenu={data} />
            ) : (
                <ArsenalSimpleMenu dataMenu={data} />
            )}
        </div>
    );
}
export default ArsenalDetails;
